"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ConfiguratorSmallSummary = void 0;

var _configuratorSmallSummary = _interopRequireDefault(require("./components/configurator-small-summary"));

exports.ConfiguratorSmallSummary = _configuratorSmallSummary["default"];